import request from "./request"

export const getLegalDocument = type => request.get("/legal/document_get", { params: { type } })
